import { DEFAULT_LOCALE, type AppLocale } from "@/lib/i18n/constants";
import type { ContentEntry, ContentObject, ContentStaticField, ContentTextField, TranslationStatus } from "./types";

export function defineContentEntry<TContent extends ContentObject>(entry: ContentEntry<TContent>): ContentEntry<TContent> {
  return entry;
}

export function text(value: string, status: TranslationStatus = "human", lang: AppLocale = DEFAULT_LOCALE): ContentTextField {
  return {
    value,
    _status: status,
    _lang: lang,
  };
}

export function staticText(value: string): ContentStaticField {
  return {
    value,
    _static: true,
  };
}

export function isContentTextField(value: unknown): value is ContentTextField {
  return (
    isRecord(value) &&
    typeof value.value === "string" &&
    (value._status === "machine" ||
      value._status === "machine_overlength" ||
      value._status === "ai_final" ||
      value._status === "human" ||
      value._status === "missing") &&
    typeof value._lang === "string"
  );
}

export function isContentStaticField(value: unknown): value is ContentStaticField {
  return isRecord(value) && typeof value.value === "string" && value._static === true;
}

export function isContentField(value: unknown): value is ContentTextField | ContentStaticField {
  return isContentTextField(value) || isContentStaticField(value);
}

export function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null && !Array.isArray(value);
}
